<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Radio/NewDSimpleRadioPreview'
export default {
  name: 'NewDBrowseSettingPreview',
  extends: compoment
}
</script>
